module.exports = __webpack_public_path__ + "static/media/bride-groom-alt.3e740860.svg";